<template>
  <el-dialog
    v-model="show"
    modal-class="ppt-display-dialog"
    top="0"
    width="100%"
    :show-close="false"    
  >
    <div style="width: 100vw; height: 1px"></div>
    <div
      @touchstart="handleTouchStart"
      @touchmove="handleTouchMove"
      @touchend="handleTouchEnd"
    >
      <div style="position: relative" class="block text-center">
        <div @click="close" class="exit-button">
          <img :src="require('@/assets/close.png')" alt="">
        </div>
        <!-- arrow="never" -->
        <el-carousel
          ref="carouselRef"
          height="100vh"
          :autoplay="autoPlay"
          :interval="10000"
          motion-blur
          indicator-position="none"
          :pause-on-hover="false"
          :loop="true"
          @change="changeCarousel"
        >
          <el-carousel-item
            style="display: flex; justify-content: center"
            v-for="(item, index) in list"
            :key="item"
          >
            <video
              style="width: 100vw; height: 100vh"
              :ref="(el) => (videoRefs[index] = el)"
              @play="handlePlay(index)"
              @ended="handleEnd"
              :data-src="item.attributes.file.url()"
              preload="metadata"
              autoplay
              muted
              v-if="isVideo(item.attributes.file.url())"
              :src="item.attributes.file.url()"
              control
            ></video>
            <img
              style="max-width: 100%; max-height: 100%; object-fit: contain"
              v-else
              :src="item.attributes.file.url()"
              alt=""
            />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import { ElDialog, ElCarousel, ElCarouselItem } from "element-plus";
import { ref, defineExpose } from "vue";

const Parse = require("parse");
Parse.initialize("4b61ad984a1", "ec8fbdb80b9ca");
Parse.serverURL = "https://hifoto.gbtops.com/api";
const SHAREFILE = Parse.Object.extend("SHAREFILE");
const query = new Parse.Query(SHAREFILE);
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
query.equalTo("theme_id", urlParams.get("theme_id"));
// query.equalTo("theme_id", 'b3505168-37a7-4f14-b0ca-be234ed804f5');

const carouselRef = ref(null);
const subscribeObj = ref({});
const open = () => {
  show.value = true;
  finish.value = false;
  getList();
  query
    .subscribe()
    .then((subscription) => {
      subscribeObj.value = subscription;
      // 当满足查询条件的对象被创建时，执行以下操作
      subscription.on("create", (object) => {
        console.log("加入");
        // carouselRef.value.setActiveItem(pptIndex.value);
        list.value.splice(list.value.length-1, 0, object);
      });

      // 当满足查询条件的对象被更新时，执行以下操作
      //   subscription.on("update", (object) => {
      //     console.log("Object updated: ", object.get("file"));
      //   });

      // 当满足查询条件的对象被删除时，执行以下操作
      subscription.on("delete", (object) => {
        console.log("Object deleted: ", object);
      });
    })
    .catch((error) => {
      console.error("Error while creating subscription: ", error);
    });
};
const close = () => {
  show.value = false;
  subscribeObj.value.unsubscribe();
};
const show = ref(false);
const startX = ref(0);
const startY = ref(0);
const endX = ref(0);
const endY = ref(0);

function handleTouchStart(event) {
  startX.value = event.touches[0].clientX;
  startY.value = event.touches[0].clientY;
}

function handleTouchMove(event) {
  endX.value = event.touches[0].clientX;
  endY.value = event.touches[0].clientY;
}

function handleTouchEnd() {
  const deltaX = endX.value - startX.value;
  const deltaY = endY.value - startY.value;

  if (Math.abs(deltaX) > Math.abs(deltaY)) {
    // 水平滑动
    if (deltaX > 50) {
      carouselRef.value.prev();
    } else if (deltaX < -50) {
      carouselRef.value.next();
    }
  }
}

const autoPlay = ref(true);
// const pptIndex = ref(0);
const list = ref([]);
const size = 3;
const finish = ref(false);
const getList = async () => {
  if (finish.value) return;
  try {
    query.descending("createdAt");
    query.skip(list.value.length);
    query.limit(size);
    const results = (await query.find()) || [];    
    if (results.length === 0) finish.value = true;
    list.value = [...list.value, ...results];
    // carouselRef.value.setActiveItem(pptIndex.value);
  } catch (error) {
    () => {};
  }
};

// const oldPptIndex = ref(0);
function changeCarousel() {
  //console.log('切换',index)
  // if (Math.abs(oldPptIndex.value - index) > 1) {
  //   carouselRef.value.setActiveItem(pptIndex.value);
  //   return;
  // }
  // pptIndex.value = index;
  // oldPptIndex.value = index;
  // if (list.value.length - 1 <= pptIndex.value) {
  //   getList();
  // }
}

const videoRefs = ref([]);

function isVideo(link) {
  return /\.(mp4|MP4)$/i.test(link);
}

function handlePlay(index) {
  videoRefs.value[index].currentTime = 0;
  autoPlay.value = false;
}
function handleEnd() {
  autoPlay.value = true;
}
defineExpose({
  open,
  close,
});
</script>

<style scoped>
.demonstration {
  color: var(--el-text-color-secondary);
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.exit-button {
  position: absolute;
  right: 5vw;
  top: 2vw;
  /* height: 140px; */
  z-index: 9999;    
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 50px;
}
img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
@media (max-width: 768px) {
  .exit-button {
  position: absolute;
  right: 20px;
  top: 20px;
  height: 40px;
  width: 40px;
}
}
</style>
<style>
.ppt-display-dialog {
  height: 100vh;
}
.ppt-display-dialog .el-dialog__body {
  padding: 0;
}
.ppt-display-dialog .el-dialog__header {
  padding: 0;
  margin: 0;
}
</style>
